var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g2, _path42, _g3, _path43, _g4, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g5, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _g6, _path268, _g7, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMAchineIllustrator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 455,
    viewBox: "0 0 488 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.367 308.427L436.409 410.94L487.408 381.937L306.366 279.448L255.367 308.427Z",
    fill: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.367 308.427L436.409 410.94L487.408 381.937L306.366 279.448L255.367 308.427Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.451 270.855C360.415 273.51 351.864 275.614 351.686 277.617C351.661 278.168 351.254 280.047 352.73 280.723C357.132 281.775 365.276 278.193 365.276 278.193C365.276 278.193 373.216 278.419 373.877 276.916C374.565 275.413 373.572 270.179 373.572 270.179C373.572 270.179 363.113 269.903 362.426 270.855H362.451Z",
    fill: "#3C2415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M385.504 285.354C385.682 287.082 380.134 294.796 381.432 296.875C382.602 298.728 388.277 298.002 390.619 296.224C392.935 294.445 394.054 288.71 394.589 286.631C395.123 284.577 394.589 281.597 394.589 281.597L385.605 282.273C385.605 282.273 385.351 283.65 385.529 285.354H385.504Z",
    fill: "#3C2415"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M339.561 194.983L378.243 216.924L372.314 226.266L340.096 238.889L339.561 194.983Z",
    fill: "#7F56D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.514 246.629L378.239 233.781V216.925L355.972 223.011L355.514 246.629Z",
    fill: "#D0D5DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M348.611 196.636C349.069 196.636 353.345 197.062 354.108 193.205C354.77 189.924 352.352 185.866 349.171 185.19C345.965 184.489 344.056 187.77 343.725 188.722C343.394 189.673 344.998 196.511 348.611 196.636Z",
    fill: "#D0D5DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M335.963 195.613C335.963 195.613 335.225 197.416 334.359 198.468C333.494 199.52 331.382 200.797 330.644 200.096C329.88 199.395 332.451 196.865 331.814 196.038C331.178 195.212 328.481 196.239 328.481 196.239C328.481 196.239 326.368 199.67 324.409 199.144C323.315 198.843 323.442 195.011 324.409 193.709C325.376 192.407 327.463 191.305 329.117 190.879C331.204 190.378 334.919 190.503 334.919 190.503L336.624 191.33L337.591 194.26L335.988 195.613H335.963Z",
    fill: "#0D0D0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M345.614 187.445C344.825 187.745 338.718 189.724 334.9 190.5C336.707 192.755 336.147 195.209 335.969 195.61C341.721 195.885 343.146 196.561 348.032 196.01C353.045 194.257 348.312 186.468 345.614 187.445Z",
    fill: "#F0C6B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M348.36 234.194L331.233 324.485L317.364 335.58L269.698 308.505V170.276L349.2 179.268L347.826 190.313L348.36 234.194Z",
    fill: "url(#paint0_linear_1487_155510)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M355.969 223.021L349.2 179.265L301.535 152.19L269.698 170.274L317.364 197.348V335.577L356.911 313.111V245.838L355.969 223.021Z",
    fill: "url(#paint1_linear_1487_155510)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M436.873 403.519L476.65 380.877V330.66L436.873 353.277V403.519Z",
    fill: "url(#paint2_linear_1487_155510)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M476.653 330.666V325.356L332.104 283.88L317.369 280.073V285.383L436.876 353.283L476.653 330.666Z",
    fill: "url(#paint3_linear_1487_155510)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M476.653 325.356L356.993 257.531L317.369 280.073L436.876 347.997L476.653 325.356Z",
    fill: "url(#paint4_linear_1487_155510)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M317.369 335.595L436.876 403.52V353.278L317.369 285.378V335.595Z",
    fill: "url(#paint5_linear_1487_155510)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M329.116 267.37L432.743 332.34L443.254 326.379V320.292L339.601 261.409L329.116 267.37Z",
    fill: "#939598"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M333.692 266.923L434.699 324.278L436.047 323.502L335.067 266.146L333.692 266.923Z",
    fill: "#454545"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M337.862 264.567L438.868 321.923L440.217 321.146L339.236 263.791L337.862 264.567Z",
    fill: "#454545"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M329.116 273.482L432.743 332.34V326.254L329.116 267.371V273.482Z",
    fill: "#808285"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M378.239 283.351L390.226 290.164V282.475L378.239 275.662V283.351Z",
    fill: "#7F56D9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M378.239 283.351L390.226 290.164V282.475L378.239 275.662V283.351Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M366.315 291.92L394.817 275.865V290.667L392.959 291.719L390.211 290.167V284.231L370.921 295.051V304.117L366.315 306.722V291.92Z",
    fill: "#D0D5DD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M368.663 260.988L394.824 275.866L366.321 291.92V306.722L340.16 291.87V277.068L368.663 260.988Z",
    fill: "url(#paint6_linear_1487_155510)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M378.229 271.426V277.387H378.178C378.178 278.915 377.16 280.442 375.099 281.594C371.002 283.924 364.334 283.924 360.237 281.594C358.176 280.417 357.158 278.915 357.158 277.387V271.426H378.204H378.229Z",
    fill: "#808285"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M360.256 275.663C364.353 277.992 370.995 277.992 375.093 275.663C379.19 273.334 379.19 269.552 375.093 267.223C370.995 264.893 364.328 264.893 360.231 267.223C356.133 269.552 356.133 273.334 360.231 275.663H360.256Z",
    fill: "#A7A9AC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M364.828 273.057C366.406 273.959 368.976 273.959 370.579 273.057C372.157 272.156 372.157 270.678 370.579 269.801C369.001 268.9 366.431 268.9 364.828 269.801C363.25 270.703 363.25 272.156 364.828 273.057Z",
    fill: "#808285"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M441.091 286.383V343.138L430.097 336.901V280.147L457.301 264.693L441.091 286.383Z",
    fill: "url(#paint7_linear_1487_155510)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M468.295 327.684L441.091 343.138V286.383L430.097 280.147L457.301 264.693L468.295 270.93V327.684Z",
    fill: "url(#paint8_linear_1487_155510)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M325.716 211.22V225.496L317.369 220.737V206.486L338.033 194.765L325.716 211.22Z",
    fill: "#808285"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M346.406 213.775L325.716 225.496V211.22L317.369 206.486L338.033 194.765L346.406 199.498V213.775Z",
    fill: "#A7A9AC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M409.327 267.549V277.392L399.428 271.782V261.914L423.935 248.038L409.327 267.549Z",
    fill: "#7F56D9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M433.835 263.517L409.327 277.392V267.549L399.428 261.914L423.935 248.038L433.835 253.673V263.517Z",
    fill: "#D0D5DD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M327.942 214.828L424.851 273.436L428.541 271.332L428.516 267.825L331.632 212.749L327.942 214.828Z",
    fill: "#808285"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M327.942 218.358L424.851 273.434V269.902L327.942 214.826V218.358Z",
    fill: "#6D6E71"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M340.564 207.663L437.448 266.271L441.138 264.192L441.112 260.66L344.229 205.584L340.564 207.663Z",
    fill: "#808285"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M340.564 211.195L437.448 266.271V262.739L340.564 207.663V211.195Z",
    fill: "#6D6E71"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M436.176 278.226V295.783L420.423 286.816V269.259L459.487 247.068L436.176 278.226Z",
    fill: "url(#paint9_linear_1487_155510)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M475.266 273.567L436.176 295.783V278.226L420.423 269.259L459.487 247.068L475.266 256.035V273.567Z",
    fill: "url(#paint10_linear_1487_155510)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M295.93 251.02L271.117 236.919V193.739L295.93 207.84V251.02Z",
    fill: "#363636"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M306.39 245.083L295.93 251.019V207.839L271.118 193.738L281.577 187.777L306.39 201.878V245.083Z",
    fill: "#5C5C5C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M293.507 227.732L273.682 216.461L283.607 205.491L293.507 227.732Z",
    fill: "#D0D5DD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M283.405 206.642L274.676 216.31L292.108 226.228L283.379 206.642H283.405ZM283.583 205.49L293.482 227.731L273.658 216.46L283.557 205.465L283.583 205.49Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M282.06 209.996L281.475 214.003L283.867 216.032L281.806 219.589L285.318 215.957L282.773 213.928L283.944 211.574L282.06 209.996Z",
    fill: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1487_155510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.16 99.8454C300.003 98.3106 302.325 97.4702 304.723 97.4702C307.121 97.4702 309.443 98.3106 311.286 99.8454M294.823 96.536C297.547 94.1345 301.054 92.8096 304.686 92.8096C308.317 92.8096 311.824 94.1345 314.549 96.536M301.451 103.164C302.397 102.492 303.529 102.13 304.69 102.13C305.851 102.13 306.983 102.492 307.93 103.164M304.686 106.79H304.695",
    stroke: "#FCFAFF",
    strokeWidth: 1.86444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.143 164.96C325.755 163.208 321.676 161.747 315.368 162.491L314.997 160.96C322.038 160.13 326.859 161.765 329.755 163.89C331.185 164.939 332.136 166.1 332.657 167.122C332.917 167.632 333.077 168.124 333.128 168.562C333.176 168.979 333.135 169.436 332.864 169.814L330.874 169.12C330.874 169.12 330.874 169.12 330.874 169.119C330.876 169.116 330.895 169.084 330.908 169.011C330.922 168.933 330.926 168.825 330.91 168.687C330.878 168.41 330.77 168.053 330.56 167.642C330.142 166.821 329.355 165.849 328.143 164.96Z",
    fill: "#475467",
    stroke: "#1D2939",
    strokeWidth: 0.259264
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1487_155510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.53 166.455C310.12 166.449 312.288 165.816 313.719 163.412C314 162.969 314.497 161.832 314.668 160.291C315.399 161.614 317.086 164.678 317.981 166.351C318.876 168.024 318.151 169.686 317.676 170.308C317.791 170.349 317.897 170.391 317.992 170.433C318.174 170.13 318.405 169.588 318.53 168.917C318.528 169.053 318.524 169.435 318.524 169.878C318.524 170.321 318.245 170.467 318.105 170.485C318.682 170.761 318.865 171.041 318.889 171.225C318.892 171.254 318.892 171.281 318.889 171.305V171.948C318.895 171.96 318.876 171.998 318.75 172.062C318.623 172.125 317.258 172.921 316.387 173.282C314.597 173.893 309.792 174.847 304.89 173.78C303.819 173.561 301.672 172.934 301.645 172.175L301.671 171.527C301.671 171.502 301.672 171.476 301.674 171.451C301.712 171.095 302.07 170.782 302.391 170.602C302.708 170.477 303.596 170.127 304.618 169.72C305.64 169.313 307.696 168.535 308.247 168.3C308.786 167.773 308.568 167.001 308.53 166.455Z",
    fill: "#D0D5DD"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M317.992 170.433C317.897 170.391 317.791 170.349 317.676 170.308C318.151 169.686 318.876 168.024 317.981 166.351C317.086 164.678 315.399 161.614 314.668 160.291C314.497 161.832 314 162.969 313.719 163.412C312.288 165.816 310.12 166.449 308.53 166.455C308.568 167.001 308.786 167.773 308.247 168.3C307.696 168.535 305.64 169.313 304.618 169.72C303.596 170.127 302.708 170.477 302.391 170.602C302.07 170.782 301.712 171.095 301.674 171.451M317.992 170.433C318.032 170.45 318.069 170.468 318.105 170.485M317.992 170.433C318.174 170.13 318.405 169.588 318.53 168.917M314.838 159.873L318.332 166.351C318.675 167.262 318.669 168.169 318.53 168.917M318.105 170.485C318.245 170.467 318.524 170.321 318.524 169.878C318.524 169.435 318.528 169.053 318.53 168.917M318.105 170.485C318.682 170.761 318.865 171.041 318.889 171.225M318.889 171.225C318.896 171.279 318.889 171.324 318.874 171.359C318.369 171.762 316.81 172.68 314.612 173.123C312.414 173.566 310.682 173.609 310.09 173.575C308.553 173.545 304.973 173.306 302.956 172.591C301.934 172.229 301.636 171.817 301.674 171.451M318.889 171.225V171.948C318.895 171.96 318.876 171.998 318.75 172.062C318.623 172.125 317.258 172.921 316.387 173.282C314.597 173.893 309.792 174.847 304.89 173.78C303.819 173.561 301.672 172.934 301.645 172.175L301.674 171.451",
    stroke: "#667085",
    strokeWidth: 0.385566
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1487_155510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.782 126.634V159.035C314.791 159.485 314.769 159.912 314.724 160.312C314.554 161.853 314.057 162.99 313.775 163.433C312.345 165.837 310.177 166.47 308.586 166.476C308.035 166.478 307.554 166.405 307.196 166.304C303.108 165.056 301.792 161.172 301.645 159.385V127.324C302.486 121.391 306.736 120.179 308.756 120.315C313.197 120.613 314.623 124.652 314.782 126.634Z",
    fill: "#A6F4C5"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M314.782 159.035V126.634C314.623 124.652 313.197 120.613 308.756 120.315C306.736 120.179 302.486 121.391 301.645 127.324V159.385C301.792 161.172 303.108 165.056 307.196 166.304C307.554 166.405 308.035 166.478 308.586 166.476C310.177 166.47 312.345 165.837 313.775 163.433C314.057 162.99 314.554 161.853 314.724 160.312C314.769 159.912 314.791 159.485 314.782 159.035ZM314.782 159.035L314.895 159.894",
    stroke: "#98A2B3",
    strokeWidth: 0.385566
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M307.031 165.21C303.188 164.703 301.918 161.042 301.763 159.275C301.609 157.507 301.65 127.496 301.65 127.496C302.256 122.82 305.317 121.515 306.771 121.447C311.022 121.547 312.122 125.235 312.141 127.066V159.953C311.716 164.466 308.558 165.338 307.031 165.21Z",
    fill: "#F2F4F7",
    stroke: "#D0D5DD",
    strokeWidth: 0.385566
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M308.075 159.748C308.075 160.26 307.927 160.741 307.67 161.093C307.413 161.445 307.047 161.666 306.607 161.666C306.165 161.666 305.737 161.443 305.418 161.089C305.1 160.736 304.893 160.256 304.893 159.748C304.893 158.722 305.481 157.932 306.361 157.932C307.25 157.932 308.075 158.732 308.075 159.748Z",
    fill: "#FCFCFD",
    stroke: "#373737",
    strokeWidth: 0.0963914
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M305.074 158.765C305.409 157.951 306.155 157.793 306.487 157.815C307.429 157.815 308.297 158.671 308.297 159.752C308.297 160.833 307.681 161.794 306.74 161.794C306.505 161.786 305.929 161.661 305.504 161.218",
    stroke: "#373737",
    strokeWidth: 0.0771131
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M307.551 159.778C307.551 160.147 307.445 160.492 307.26 160.745C307.076 160.997 306.815 161.155 306.501 161.155C306.185 161.155 305.878 160.995 305.649 160.741C305.42 160.487 305.272 160.142 305.272 159.778C305.272 159.04 305.695 158.476 306.323 158.476C306.959 158.476 307.551 159.049 307.551 159.778Z",
    stroke: "#373737",
    strokeWidth: 0.0937824
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M307.566 159.777C307.566 160.162 307.455 160.521 307.265 160.781C307.075 161.04 306.81 161.2 306.492 161.2C306.171 161.2 305.855 161.037 305.618 160.773C305.381 160.51 305.228 160.153 305.228 159.777C305.228 159.004 305.668 158.434 306.302 158.434C306.954 158.434 307.566 159.024 307.566 159.777Z",
    stroke: "#373737",
    strokeWidth: 0.192783
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M307.271 159.784C307.271 160.062 307.191 160.323 307.052 160.513C306.914 160.703 306.718 160.821 306.483 160.821C306.247 160.821 306.016 160.701 305.844 160.509C305.671 160.318 305.56 160.058 305.56 159.784C305.56 159.225 305.879 158.804 306.348 158.804C306.825 158.804 307.271 159.235 307.271 159.784Z",
    fill: "#7F56D9",
    stroke: "#373737",
    strokeWidth: 0.0963914
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M319.735 127.036L317.303 128.791",
    stroke: "#32D583",
    strokeWidth: 0.259264
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M319.985 132.029L317.252 130.309",
    stroke: "#32D583",
    strokeWidth: 0.259264
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M317.231 127.035L321.801 121.852",
    stroke: "#32D583",
    strokeWidth: 0.518528
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M316.723 129.531L324.091 129.53",
    stroke: "#32D583",
    strokeWidth: 0.518528
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M316.849 131.693L321.351 135.996",
    stroke: "#32D583",
    strokeWidth: 0.518528
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M286.048 379.261C284.642 378.79 283.092 378.413 281.493 378.177V373.579H272.481V378.153C270.882 378.389 269.356 378.743 267.927 379.238L262.21 376.031L255.451 379.827L261.362 383.152C260.708 383.835 260.175 384.59 259.811 385.344H251.575V390.932H259.811C260.175 391.71 260.708 392.441 261.362 393.125L255.451 396.449L262.21 400.245L267.927 397.015C269.356 397.51 270.882 397.864 272.481 398.1V402.698H281.493V398.123C283.116 397.888 284.642 397.51 286.048 397.039L291.765 400.269L298.524 396.473L292.613 393.149C293.267 392.465 293.8 391.71 294.163 390.956H302.4V385.368H294.163C293.8 384.59 293.267 383.859 292.613 383.175L298.524 379.851L291.765 376.055L286.048 379.261ZM285.902 386.948C286.726 389.188 285.079 391.592 281.687 392.795C278.828 393.809 275.146 393.809 272.287 392.795C270.107 392.017 268.605 390.791 268.072 389.329C267.685 388.315 267.806 387.278 268.363 386.311C269.066 385.132 270.422 384.166 272.287 383.482C275.146 382.468 278.828 382.468 281.687 383.482C283.867 384.26 285.369 385.486 285.902 386.948Z",
    fill: "#42307D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M301.473 383.576L292.049 382.349L297.742 379.166V372.871L285.726 376.502C284.37 376.031 282.892 374.993 281.317 374.757V373.131H272.645V374.757C271.094 374.993 269.616 376.031 268.26 376.502L256.244 372.848V379.143L261.937 382.349C261.307 383.01 259.878 381.784 259.539 382.538L252.513 383.576V389.871H256.244V395.176L262.761 398.83L268.284 395.718C269.665 396.19 271.118 396.543 272.669 396.755V401.164H281.342V396.755C282.892 396.52 284.37 396.166 285.751 395.694L291.274 398.807L297.791 395.152V389.847H301.521V384.448V383.552L301.473 383.576ZM281.511 388.904C278.749 389.894 275.212 389.894 272.451 388.904C270.343 388.15 268.89 389.706 268.381 388.315C268.017 387.348 268.114 386.334 268.672 385.391C269.35 384.259 270.658 383.316 272.451 382.68C275.212 381.689 278.749 381.689 281.511 382.68C283.619 383.434 285.048 384.613 285.581 386.004C286.38 388.173 284.782 387.725 281.511 388.904Z",
    fill: "#7F56D9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M285.707 372.306C284.35 371.834 282.873 371.504 281.298 371.268V366.859H272.625V371.268C271.075 371.504 269.597 371.834 268.24 372.306L262.717 369.217L256.2 372.872L261.893 376.078C261.264 376.738 260.755 377.446 260.391 378.2H252.47V383.6H260.391C260.755 384.354 261.239 385.061 261.893 385.722L256.2 388.904L262.717 392.559L268.24 389.447C269.621 389.918 271.075 390.272 272.625 390.484V394.893H281.298V390.484C282.848 390.248 284.326 389.895 285.707 389.447L291.23 392.535L297.747 388.881L292.054 385.674C292.684 385.014 293.193 384.307 293.532 383.552H301.478V378.153H293.556C293.193 377.399 292.708 376.691 292.054 376.031L297.747 372.848L291.23 369.194L285.707 372.282V372.306ZM285.562 379.709C286.361 381.878 284.762 384.189 281.492 385.344C278.73 386.335 275.193 386.335 272.431 385.344C270.324 384.59 268.87 383.411 268.362 381.996C267.998 381.03 268.095 380.016 268.652 379.073C269.331 377.941 270.639 376.998 272.431 376.338C275.193 375.347 278.73 375.347 281.492 376.338C283.599 377.092 285.029 378.271 285.562 379.662V379.709Z",
    fill: "#B692F6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M167.993 391.459C166.588 390.987 165.037 390.61 163.438 390.374V385.776H154.427V390.35C152.828 390.586 151.302 390.94 149.872 391.435L144.155 388.228L137.396 392.024L143.307 395.349C142.653 396.033 142.12 396.787 141.757 397.542H133.52V403.13H141.757C142.12 403.908 142.653 404.639 143.307 405.322L137.396 408.647L144.155 412.443L149.872 409.213C151.302 409.708 152.828 410.061 154.427 410.297V414.895H163.438V410.321C165.062 410.085 166.588 409.708 167.993 409.236L173.71 412.466L180.469 408.67L174.558 405.346C175.212 404.662 175.745 403.908 176.108 403.153H184.345V397.565H176.108C175.745 396.787 175.212 396.056 174.558 395.372L180.469 392.048L173.71 388.252L167.993 391.459ZM167.847 399.145C168.671 401.385 167.024 403.79 163.632 404.992C160.774 406.006 157.091 406.006 154.233 404.992C152.053 404.214 150.551 402.988 150.018 401.526C149.63 400.512 149.751 399.475 150.308 398.508C151.011 397.329 152.367 396.363 154.233 395.679C157.091 394.665 160.774 394.665 163.632 395.679C165.813 396.457 167.315 397.683 167.847 399.145Z",
    fill: "#42307D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M183.418 395.773L173.995 394.547L179.688 391.364V385.069L167.672 388.699C166.315 388.228 164.837 387.191 163.263 386.955V385.328H154.59V386.955C153.04 387.191 151.562 388.228 150.205 388.699L138.189 385.045V391.34L143.882 394.547C143.252 395.207 141.823 393.981 141.484 394.735L134.459 395.773V402.068H138.189V407.373L144.706 411.028L150.229 407.915C151.61 408.387 153.064 408.74 154.614 408.953V413.362H163.287V408.953C164.837 408.717 166.315 408.363 167.696 407.892L173.219 411.004L179.736 407.349V402.044H183.467V396.645V395.749L183.418 395.773ZM163.457 401.101C160.695 402.092 157.158 402.092 154.396 401.101C152.289 400.347 150.835 401.903 150.326 400.512C149.963 399.545 150.06 398.531 150.617 397.588C151.295 396.457 152.604 395.513 154.396 394.877C157.158 393.887 160.695 393.887 163.457 394.877C165.564 395.631 166.993 396.81 167.526 398.201C168.326 400.37 166.727 399.922 163.457 401.101Z",
    fill: "#7F56D9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M167.679 384.503C166.323 384.032 164.845 383.701 163.27 383.466V379.057H154.597V383.466C153.047 383.701 151.569 384.032 150.213 384.503L144.689 381.414L138.173 385.069L143.866 388.276C143.236 388.936 142.727 389.643 142.364 390.398H134.442V395.797H142.364C142.727 396.551 143.212 397.259 143.866 397.919L138.173 401.102L144.689 404.756L150.213 401.644C151.594 402.116 153.047 402.469 154.597 402.681V407.091H163.27V402.681C164.821 402.446 166.298 402.092 167.679 401.644L173.203 404.733L179.719 401.078L174.026 397.872C174.656 397.211 175.165 396.504 175.504 395.75H183.45V390.35H175.528C175.165 389.596 174.68 388.889 174.026 388.228L179.719 385.045L173.203 381.391L167.679 384.48V384.503ZM167.534 391.906C168.333 394.076 166.734 396.386 163.464 397.542C160.702 398.532 157.165 398.532 154.404 397.542C152.296 396.787 150.843 395.608 150.334 394.194C149.97 393.227 150.067 392.213 150.624 391.27C151.303 390.138 152.611 389.195 154.404 388.535C157.165 387.545 160.702 387.545 163.464 388.535C165.572 389.289 167.001 390.468 167.534 391.859V391.906Z",
    fill: "#B692F6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M240.367 413.705C237.945 412.879 235.28 412.243 232.494 411.842V403.943H216.965V411.842C214.204 412.243 211.563 412.879 209.092 413.705L199.232 408.164L187.604 414.695L197.779 420.401C196.64 421.579 195.72 422.876 195.114 424.197H180.942V433.84H195.114C195.744 435.184 196.64 436.433 197.779 437.636L187.628 443.342L199.257 449.873L209.116 444.332C211.563 445.157 214.204 445.794 216.99 446.195V454.093H232.518V446.195C235.304 445.77 237.945 445.157 240.391 444.332L250.251 449.873L261.879 443.342L251.705 437.636C252.843 436.457 253.74 435.184 254.37 433.84H268.566V424.197H254.394C253.764 422.853 252.868 421.603 251.729 420.401L261.904 414.695L250.275 408.164L240.416 413.705H240.367ZM240.125 426.955C241.554 430.822 238.696 434.948 232.857 437.046C227.94 438.815 221.568 438.815 216.65 437.046C212.896 435.703 210.303 433.58 209.383 431.081C208.729 429.337 208.923 427.545 209.892 425.871C211.103 423.819 213.428 422.145 216.65 420.99C221.568 419.222 227.94 419.222 232.857 420.99C236.612 422.334 239.204 424.456 240.125 426.955Z",
    fill: "#42307D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M266.944 421.111L250.713 419.012L260.524 413.519V402.673L239.812 408.944C237.462 408.143 234.918 406.351 232.229 405.95V403.144H217.282V405.95C214.617 406.351 212.073 408.143 209.699 408.944L188.987 402.673V413.519L198.774 419.036C197.659 420.191 195.237 418.069 194.631 419.342L182.518 421.134V431.98H188.962V441.128L200.179 447.423L209.675 442.071C212.049 442.873 214.569 443.486 217.258 443.863V451.479H232.205V443.887C234.894 443.486 237.413 442.873 239.787 442.095L249.284 447.447L260.5 441.152V432.003H266.944V422.714V421.158V421.111ZM232.544 430.306C227.796 432.004 221.667 432.004 216.943 430.306C213.309 429.009 210.814 431.697 209.942 429.292C209.312 427.618 209.481 425.873 210.45 424.27C211.613 422.313 213.866 420.686 216.943 419.578C221.691 417.88 227.82 417.88 232.568 419.578C236.202 420.875 238.673 422.926 239.569 425.307C240.95 429.033 238.188 428.278 232.568 430.306H232.544Z",
    fill: "#7F56D9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M239.787 401.705C237.437 400.904 234.894 400.314 232.205 399.913V392.298H217.258V399.913C214.593 400.314 212.049 400.904 209.675 401.705L200.179 396.353L188.962 402.648L198.749 408.166C197.635 409.321 196.787 410.547 196.181 411.82H182.518V421.11H196.181C196.787 422.383 197.659 423.609 198.749 424.764L188.962 430.258L200.179 436.553L209.675 431.201C212.049 432.003 214.569 432.616 217.258 432.993V440.609H232.205V433.017C234.894 432.616 237.413 432.026 239.787 431.225L249.284 436.577L260.5 430.282L250.713 424.788C251.803 423.633 252.675 422.43 253.281 421.133H266.944V411.844H253.281C252.675 410.571 251.803 409.345 250.713 408.189L260.524 402.696L249.308 396.4L239.812 401.729L239.787 401.705ZM239.545 414.484C240.926 418.21 238.164 422.194 232.544 424.198C227.796 425.896 221.667 425.896 216.943 424.198C213.309 422.902 210.814 420.85 209.942 418.446C209.312 416.771 209.481 415.027 210.45 413.423C211.613 411.467 213.866 409.84 216.943 408.732C221.691 407.034 227.82 407.034 232.568 408.732C236.202 410.028 238.673 412.08 239.569 414.461L239.545 414.484Z",
    fill: "#B692F6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.221 283.781L61.2768 344.349C61.0621 344.214 60.901 344.08 60.6862 343.972C47.0212 336.061 69.665 338.089 56 346C42.335 353.911 32 360.5 14 371.5C12.5 372.5 12.5 372.5 11.8519 372.897L4.09314 377.364L55.3437 407.042L217.471 313.46L166.221 283.808V283.781Z",
    fill: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.221 283.781L61.2768 344.349C61.0621 344.214 60.901 344.08 60.6862 343.972C47.0212 336.061 69.665 338.089 56 346C42.335 353.911 32 360.5 14 371.5C12.5 372.5 12.5 372.5 11.8519 372.897L4.09314 377.364L55.3437 407.042L217.471 313.46L166.221 283.808V283.781Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M106.861 159.174V329.98L147.239 306.624V135.792L113.895 116.5L106.861 159.174Z",
    fill: "url(#paint11_linear_1487_155510)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9286 300.521L106.857 329.984V159.179L147.235 135.797L96.3062 106.334L55.9286 129.716V300.521Z",
    fill: "url(#paint12_linear_1487_155510)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5021 185.257L90.6096 182.889C91.2271 182.566 92.0594 182.62 92.999 183.158C94.8783 184.235 96.3817 186.845 96.3817 189.024C96.3817 190.1 96.0058 190.854 95.3884 191.23L91.2808 193.598L86.5021 185.284V185.257Z",
    fill: "#A62626"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2739 191.361C92.2739 189.209 90.7705 186.572 88.8912 185.496C87.0388 184.419 85.5085 185.28 85.5085 187.433C85.5085 189.585 87.012 192.222 88.8912 193.299C90.7705 194.375 92.2739 193.514 92.2739 191.361Z",
    fill: "#D63A3A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5251 152.506L85.8936 151.726C86.1082 151.618 86.3765 151.645 86.6985 151.806C87.3156 152.156 87.8254 153.043 87.8254 153.769C87.8254 154.119 87.6913 154.388 87.5034 154.496L86.135 155.275L84.5251 152.506Z",
    fill: "#1C4B94"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4543 154.551C86.4543 153.825 85.9445 152.964 85.3274 152.588C84.7102 152.238 84.2004 152.534 84.2004 153.233C84.2004 153.932 84.7102 154.847 85.3274 155.196C85.9445 155.546 86.4543 155.25 86.4543 154.551Z",
    fill: "#2565C4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5251 160.358L85.8936 159.551C86.1082 159.443 86.3765 159.47 86.6985 159.632C87.3156 159.981 87.8254 160.869 87.8254 161.595C87.8254 161.944 87.6913 162.213 87.5034 162.321L86.135 163.101L84.5251 160.331V160.358Z",
    fill: "#1C4B94"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4543 162.396C86.4543 161.67 85.9445 160.81 85.3274 160.433C84.7102 160.084 84.2004 160.353 84.2004 161.079C84.2004 161.805 84.7102 162.665 85.3274 163.042C85.9445 163.418 86.4543 163.122 86.4543 162.396Z",
    fill: "#2565C4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5251 168.215L85.8936 167.408C86.1082 167.301 86.3765 167.328 86.6985 167.489C87.3156 167.839 87.8254 168.726 87.8254 169.452C87.8254 169.802 87.6913 170.071 87.5034 170.178L86.135 170.958L84.5251 168.188V168.215Z",
    fill: "#1C4B94"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4543 170.254C86.4543 169.528 85.9445 168.667 85.3274 168.291C84.7102 167.941 84.2004 168.21 84.2004 168.936C84.2004 169.662 84.7102 170.523 85.3274 170.899C85.9445 171.276 86.4543 170.98 86.4543 170.254Z",
    fill: "#2565C4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9967 174.73V176.667L59.687 163.752V136.253L61.3247 137.195V162.783L81.9967 174.73Z",
    fill: "#D0D5DD"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0026 149.174V174.735L61.3306 162.789V137.2L82.0026 149.174Z",
    fill: "#0D0D0D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1518 150.918V152.183L62.8558 142.765V141.474L79.1518 150.918Z",
    fill: "#75C425"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1518 154.443V155.735L62.8558 146.291V144.999L79.1518 154.443Z",
    fill: "#75C425"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1518 157.61V158.902L62.8558 149.458V148.166L79.1518 157.61Z",
    fill: "#75C425"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0173 159.636V160.928L62.8558 156.219V154.928L71.0173 159.636Z",
    fill: "#75C425"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9571 165.471V166.763L62.8558 159.202V157.938L75.9571 165.471Z",
    fill: "#75C425"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M102.094 163.726L100.698 164.533L90.9521 154.093L92.3213 153.286L102.094 158.91V163.726Z",
    fill: "#1C4B94"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M100.697 164.539L90.9519 158.888V154.099L100.697 159.749V164.539Z",
    fill: "#2565C4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M102.093 171.583L100.697 172.391L90.9519 161.951L92.3211 161.144L102.093 166.794V171.583Z",
    fill: "#A62626"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M100.697 172.395L90.9519 166.745V161.955L100.697 167.606V172.395Z",
    fill: "#D63A3A"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M102.093 179.441L100.697 180.275L90.9519 169.808L92.3211 169.001L102.093 174.651V179.441Z",
    fill: "#61A31F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M100.697 180.279L90.9519 174.629V169.812L100.697 175.463V180.279Z",
    fill: "#75C425"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3557 177.283C87.5705 177.632 87.8657 177.955 88.1073 178.09C88.4025 178.251 88.5367 178.197 88.5367 177.982C88.5367 177.767 88.3757 177.578 88.1073 177.309L87.7047 176.879C87.3826 176.556 87.0873 176.072 87.0873 175.561C87.0873 174.969 87.5436 174.781 88.1878 175.13C88.5367 175.346 88.9125 175.722 89.1809 176.18L88.832 176.476C88.6441 176.18 88.4562 175.964 88.1878 175.83C87.9462 175.695 87.7852 175.722 87.7852 175.911C87.7852 176.126 87.9999 176.314 88.2415 176.61L88.6441 177.014C89.0198 177.39 89.2614 177.821 89.2614 178.332C89.2614 178.923 88.832 179.192 88.1073 178.762C87.7047 178.52 87.2752 178.116 86.98 177.605L87.3826 177.283H87.3557Z",
    fill: "#D63A3A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2831 177.095L89.451 176.611V175.938L91.813 177.31V177.983L90.981 177.499V180.377L90.2831 179.974V177.095Z",
    fill: "#D63A3A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5355 181.021L92.5961 180.483L92.4082 181.21L91.7103 180.806L92.6766 177.82L93.5086 178.305L94.4749 182.393L93.7502 181.963L93.5623 181.021H93.5355ZM93.4013 180.322L93.3207 179.945C93.2402 179.542 93.1597 179.085 93.0792 178.654C92.9987 178.977 92.9181 179.354 92.8376 179.65L92.7571 179.945L93.4013 180.322Z",
    fill: "#D63A3A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4616 183.524L95.8711 181.91L95.4953 181.695V182.959L94.7975 182.556V179.005L95.898 179.65C96.5421 180.027 97.0789 180.592 97.0789 181.426C97.0789 181.937 96.8642 182.152 96.5421 182.125L97.24 183.955L96.4616 183.497V183.524ZM95.4953 181.049L95.8443 181.265C96.1932 181.48 96.4079 181.399 96.4079 181.049C96.4079 180.7 96.22 180.484 95.8443 180.269L95.4953 180.054V181.049Z",
    fill: "#D63A3A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1991 181.665L97.3671 181.18V180.508L99.7559 181.88V182.552L98.9238 182.068V184.946L98.226 184.543V181.665H98.1991Z",
    fill: "#D63A3A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8793 173.763L63.7452 175.969V171.503L59.8793 169.27V173.763Z",
    fill: "#D63A3A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8793 179.683L63.7452 181.89V177.45L59.8793 175.217V179.683Z",
    fill: "#D63A3A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8793 185.603L63.7452 187.837V183.37L59.8793 181.137V185.603Z",
    fill: "#75C425"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0165 176.724L68.8824 178.931V174.464L65.0165 172.258V176.724Z",
    fill: "#D63A3A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0166 182.642L68.8825 184.849V180.409L65.0166 178.176V182.642Z",
    fill: "#2565C4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0166 188.563L68.8825 190.797V186.33L65.0166 184.097V188.563Z",
    fill: "#75C425"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M70.139 175.219V179.685L73.9781 181.892V177.452L70.139 175.219Z",
    fill: "#2565C4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1392 185.603L73.9783 187.837V183.37L70.1392 181.137V185.603Z",
    fill: "#D63A3A"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M70.139 191.522L73.9781 193.755V189.289L70.139 187.056V191.522Z",
    fill: "#D63A3A"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2106 248.81L75.5454 238.585V207.266L82.982 202.934L100.674 213.185L93.2106 217.49V248.81Z",
    fill: "#363636"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M100.672 244.504L93.2085 248.809V217.49L100.672 213.185V244.504Z",
    fill: "#5C5C5C"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4792 231.91L77.3578 223.757L84.4185 215.766L91.4792 231.91Z",
    fill: "#98A2B3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2843 216.626L90.4859 230.833L78.0558 223.649L84.2574 216.626H84.2843ZM84.4185 215.792L77.3578 223.756L91.4792 231.936L84.4185 215.792Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3185 219.05L82.9158 221.956L84.6071 223.436L83.1574 226.019L85.6541 223.382L83.8286 221.902L84.6608 220.207L83.3185 219.05Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7884 302.947L162.68 226.047L168.345 236.245L168.291 294.256L24.0701 377.694L24.1238 319.683L29.7884 302.947Z",
    fill: "#D0D5DD"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M26.756 301.201L29.7897 302.95L24.125 319.686L21.0913 317.937L26.756 301.201Z",
    fill: "url(#paint13_linear_1487_155510)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7505 301.198L159.642 224.298L162.676 226.047L29.7842 302.947L26.7505 301.198Z",
    fill: "url(#paint14_linear_1487_155510)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0912 317.941L57.7908 339.171L57.7639 397.182L21.0912 375.953V317.941Z",
    fill: "url(#paint15_linear_1487_155510)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3824 301.866V303.588L66.5777 294.762V285.237L65.4233 285.91V293.74L51.3824 301.866Z",
    fill: "#344054"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3824 294.055V301.858L65.4233 293.732V285.902L51.3824 294.055Z",
    fill: "url(#paint16_linear_1487_155510)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1169 315.86L47.9432 305.554V296.029L46.7888 296.702V304.505L30.976 313.653L30.1169 315.86Z",
    fill: "#344054"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9735 313.649L46.7863 304.5V296.697L34.7858 303.639L30.9735 313.649Z",
    fill: "url(#paint17_linear_1487_155510)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M144.639 247.862V249.584L162.438 239.279L157.793 232.444L157.471 232.66L161.284 238.229L144.639 247.862Z",
    fill: "#344054"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M144.639 240.061V247.864L161.284 238.231L157.471 232.661L144.639 240.061Z",
    fill: "url(#paint18_linear_1487_155510)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0079 291.077V292.799L85.2032 284.001V274.476L84.0488 275.148V282.951L70.0079 291.077Z",
    fill: "#344054"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0079 283.269V291.072L84.0488 282.947V275.144L70.0079 283.269Z",
    fill: "url(#paint19_linear_1487_155510)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6459 280.282V282.004L103.841 273.206V263.681L102.687 264.353V272.156L88.6459 280.282Z",
    fill: "#344054"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M88.646 272.478V280.281L102.687 272.156V264.353L88.646 272.478Z",
    fill: "url(#paint20_linear_1487_155510)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M107.281 269.497V271.219L122.477 262.421V252.896L121.322 253.568V261.371L107.281 269.497Z",
    fill: "#344054"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M107.281 261.69V269.493L121.322 261.367V253.564L107.281 261.69Z",
    fill: "url(#paint21_linear_1487_155510)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M125.902 258.735V260.457L141.097 251.658V242.106L139.943 242.779V250.609L125.902 258.735Z",
    fill: "#344054"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M125.902 250.927V258.73L139.943 250.604V242.774L125.902 250.927Z",
    fill: "url(#paint22_linear_1487_155510)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M177.691 228.118C177.691 228.118 177.584 228.064 177.53 228.037C176.779 227.66 175.759 227.741 174.658 228.387L123.112 258.2L19.537 318.149C19.4027 318.229 19.2417 318.31 19.1074 318.418C16.9865 319.897 15.322 322.965 15.322 325.467V325.871C15.322 327.216 15.7784 328.158 16.557 328.588L41.954 343.28L202.901 242.675L177.718 228.118H177.691Z",
    fill: "url(#paint23_linear_1487_155510)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M203.281 245.907V246.284C203.281 248.436 201.75 251.073 199.898 252.149L44.7771 341.911C43.6764 342.557 42.7099 342.503 42.0924 341.911C42.5756 341.911 43.1126 341.776 43.7032 341.454L198.824 251.692C200.676 250.616 202.207 247.979 202.207 245.826V245.45C202.207 244.562 201.938 243.889 201.509 243.485C202.556 243.539 203.281 244.427 203.281 245.907Z",
    fill: "#212121"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M202.176 245.473V245.85C202.176 248.002 200.645 250.639 198.793 251.715L43.6722 341.477C43.0816 341.8 42.5446 341.961 42.0614 341.934C41.6319 341.531 41.3634 340.858 41.3634 339.97V339.567C41.3634 337.414 42.8937 334.777 44.7461 333.701L199.867 243.939C200.458 243.589 200.994 243.455 201.478 243.482C201.907 243.885 202.176 244.558 202.176 245.446V245.473Z",
    fill: "#878787"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M199.894 243.966C201.746 242.889 203.276 243.777 203.276 245.93V246.307C203.276 248.459 201.746 251.096 199.894 252.172L44.7727 341.934C42.9203 343.01 41.39 342.149 41.39 339.97V339.566C41.39 337.413 42.9203 334.777 44.7727 333.7L199.894 243.939V243.966ZM199.894 242.997L44.7727 332.759C42.437 334.104 40.5309 337.387 40.5309 340.104V340.508C40.5309 343.198 42.437 344.302 44.7727 342.956L199.894 253.195C202.229 251.849 204.108 248.567 204.108 245.849V245.472C204.108 242.782 202.202 241.679 199.894 243.024V242.997Z",
    fill: "#363636"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M120.452 259.708L122.144 258.739L147.38 273.35L145.715 274.318L120.452 259.708Z",
    fill: "#363636"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M113.715 263.607L115.38 262.639L140.643 277.249L138.951 278.218L113.715 263.607Z",
    fill: "#363636"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M106.957 267.511L108.621 266.542L133.884 281.179L132.193 282.148L106.957 267.511Z",
    fill: "#363636"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M100.183 271.436L101.848 270.468L127.111 285.078L125.446 286.047L100.183 271.436Z",
    fill: "#363636"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M93.415 275.344L95.0795 274.375L120.342 288.985L118.678 289.981L93.415 275.344Z",
    fill: "#363636"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6537 279.269L88.3182 278.301L113.581 292.911L111.917 293.88L86.6537 279.269Z",
    fill: "#363636"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M79.895 283.175L81.5595 282.206L106.822 296.817L105.158 297.785L79.895 283.175Z",
    fill: "#363636"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1262 287.098L74.8176 286.103L100.08 300.74L98.3891 301.709L73.1262 287.098Z",
    fill: "#363636"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3533 290.995L68.0446 290.026L93.3075 304.637L91.6161 305.605L66.3533 290.995Z",
    fill: "#363636"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M167.781 232.324L169.472 231.355L194.708 245.966L193.044 246.935L167.781 232.324Z",
    fill: "#363636"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M161.019 236.216L162.711 235.247L187.974 249.858L186.282 250.826L161.019 236.216Z",
    fill: "#363636"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M154.28 240.147L155.945 239.179L181.207 253.789L179.543 254.758L154.28 240.147Z",
    fill: "#363636"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M147.514 244.044L149.179 243.075L174.442 257.686L172.777 258.654L147.514 244.044Z",
    fill: "#363636"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M140.753 247.973L142.417 246.978L167.68 261.615L166.016 262.584L140.753 247.973Z",
    fill: "#363636"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M133.987 251.877L135.651 250.908L160.914 265.519L159.25 266.487L133.987 251.877Z",
    fill: "#363636"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M127.228 255.776L128.893 254.808L154.155 269.445L152.491 270.387L127.228 255.776Z",
    fill: "#363636"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6211 294.897L61.2856 293.929L86.5484 308.566L84.8571 309.535L59.6211 294.897Z",
    fill: "#363636"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8455 298.826L54.5099 297.857L79.7728 312.468L78.1083 313.437L52.8455 298.826Z",
    fill: "#363636"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0914 302.731L47.7559 301.763L73.0188 316.373L71.3543 317.342L46.0914 302.731Z",
    fill: "#363636"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3206 306.656L40.985 305.688L66.2479 320.298L64.5834 321.267L39.3206 306.656Z",
    fill: "#363636"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5618 310.558L34.2263 309.59L59.4891 324.2L57.8246 325.169L32.5618 310.558Z",
    fill: "#363636"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7935 314.464L27.4848 313.495L52.7208 328.132L51.0563 329.101L25.7935 314.464Z",
    fill: "#363636"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M19.061 318.392L20.7255 317.424L45.9884 332.034L44.297 333.003L19.061 318.392Z",
    fill: "#363636"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3119 330.983L53.3186 330.472C52.9159 330.284 52.3789 330.338 51.7883 330.687C50.4997 331.441 49.4526 333.244 49.4526 334.723C49.4526 335.504 49.7479 336.042 50.2043 336.257L50.8755 336.58L51.0366 336.338C51.2782 336.284 51.5198 336.203 51.7615 336.042C53.0501 335.288 54.0971 333.486 54.0971 332.006C54.0971 331.791 54.0703 331.575 54.0166 331.414L54.2851 330.956L54.3119 330.983Z",
    fill: "#A6A6A6"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8724 332.412C54.8724 333.892 53.8254 335.722 52.5367 336.448C51.2481 337.202 50.201 336.583 50.201 335.103C50.201 333.623 51.2481 331.82 52.5367 331.067C53.8254 330.313 54.8724 330.932 54.8724 332.412Z",
    fill: "#5C5C5C"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7195 333.082C53.7195 333.835 53.2097 334.722 52.5658 335.099C52.1096 335.341 51.734 335.287 51.5461 334.991C51.6803 334.991 51.8681 334.937 52.0291 334.83C52.6731 334.453 53.1829 333.566 53.1829 332.813C53.1829 332.571 53.1292 332.383 53.0487 332.248C53.4512 332.248 53.7195 332.544 53.7195 333.082Z",
    fill: "#A6A6A6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1918 332.813C53.1918 333.539 52.682 334.453 52.038 334.83C51.877 334.937 51.6892 334.991 51.555 334.991C51.4745 334.857 51.4209 334.668 51.4209 334.426C51.4209 333.673 51.9307 332.786 52.5747 332.409C52.7356 332.302 52.8966 332.275 53.0576 332.248C53.1381 332.383 53.1918 332.571 53.1918 332.813Z",
    fill: "#4A4A4A"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8274 323.153L66.8341 322.642C66.4314 322.454 65.8944 322.508 65.3038 322.857C64.0152 323.611 62.9681 325.413 62.9681 326.893C62.9681 327.674 63.2635 328.212 63.7198 328.427L64.391 328.75L64.5521 328.508C64.7937 328.454 65.0353 328.373 65.277 328.212C66.5656 327.458 67.6126 325.656 67.6126 324.176C67.6126 323.96 67.6126 323.745 67.5321 323.584L67.8006 323.126L67.8274 323.153Z",
    fill: "#A6A6A6"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3875 324.58C68.3875 326.06 67.3405 327.863 66.0519 328.616C64.7632 329.37 63.7162 328.751 63.7162 327.271C63.7162 325.791 64.7632 323.988 66.0519 323.235C67.3405 322.481 68.3875 323.1 68.3875 324.58Z",
    fill: "#5C5C5C"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2105 325.253C67.2105 326.006 66.7007 326.893 66.0567 327.269C65.6274 327.512 65.2249 327.458 65.0371 327.162C65.1713 327.162 65.3591 327.108 65.5201 327.001C66.164 326.624 66.6738 325.737 66.6738 324.984C66.6738 324.742 66.6202 324.553 66.5397 324.419C66.9421 324.419 67.2105 324.715 67.2105 325.253Z",
    fill: "#A6A6A6"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6685 324.984C66.6685 325.737 66.1587 326.624 65.5147 327.001C65.3269 327.108 65.1659 327.162 65.0317 327.162C64.9513 327.027 64.8976 326.839 64.8976 326.597C64.8976 325.844 65.4342 324.957 66.0513 324.58C66.2123 324.473 66.4002 324.419 66.5343 324.419C66.6148 324.553 66.6685 324.742 66.6685 324.984Z",
    fill: "#4A4A4A"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6752 316.321L78.6818 315.81C78.2791 315.622 77.7422 315.675 77.1516 316.025C75.8629 316.752 74.8159 318.581 74.8159 320.061C74.8159 320.842 75.1112 321.38 75.5676 321.595L76.2388 321.918L76.3999 321.676C76.6415 321.622 76.8831 321.541 77.1247 321.38C78.4134 320.626 79.4604 318.824 79.4604 317.344C79.4604 317.128 79.4336 316.913 79.3799 316.752L79.6483 316.294L79.6752 316.321Z",
    fill: "#A6A6A6"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2358 317.748C80.2358 319.228 79.1888 321.031 77.9001 321.784C76.6115 322.538 75.5645 321.919 75.5645 320.439C75.5645 318.959 76.6115 317.156 77.9001 316.403C79.1888 315.649 80.2358 316.268 80.2358 317.748Z",
    fill: "#5C5C5C"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0582 318.419C79.0582 319.172 78.5484 320.059 77.9045 320.435C77.4752 320.677 77.0727 320.624 76.8849 320.328C77.0459 320.328 77.2069 320.274 77.3679 320.167C78.0118 319.79 78.5216 318.903 78.5216 318.15C78.5216 317.908 78.4679 317.719 78.3874 317.585C78.7899 317.585 79.0582 317.881 79.0582 318.419Z",
    fill: "#A6A6A6"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5167 318.149C78.5167 318.902 78.0069 319.789 77.363 320.166C77.202 320.273 77.0142 320.327 76.88 320.327C76.7995 320.192 76.7458 320.004 76.7458 319.762C76.7458 319.009 77.2556 318.122 77.8996 317.745C78.0606 317.638 78.2484 317.584 78.3826 317.584C78.4899 317.718 78.5167 317.907 78.5167 318.149Z",
    fill: "#4A4A4A"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4961 309.484L90.5028 308.973C90.1001 308.785 89.5631 308.865 88.9725 309.188C87.6839 309.942 86.6368 311.745 86.6368 313.224C86.6368 314.005 86.9322 314.543 87.3886 314.785L88.0597 315.108L88.2208 314.866C88.4624 314.812 88.704 314.731 88.9457 314.597C90.2343 313.843 91.2813 312.041 91.2813 310.561C91.2813 310.345 91.2813 310.157 91.2008 309.969L91.4693 309.511L91.4961 309.484Z",
    fill: "#A6A6A6"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0589 310.905C92.0589 312.385 91.0119 314.188 89.7232 314.941C88.4346 315.695 87.3876 315.076 87.3876 313.596C87.3876 312.116 88.4346 310.313 89.7232 309.56C91.0119 308.807 92.0589 309.425 92.0589 310.905Z",
    fill: "#5C5C5C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8964 311.587C90.8964 312.313 90.3866 313.227 89.7426 313.603C89.3133 313.872 88.9108 313.792 88.723 313.496C88.8572 313.496 89.045 313.442 89.206 313.335C89.8499 312.958 90.3597 312.071 90.3597 311.318C90.3597 311.103 90.3061 310.887 90.2256 310.753C90.6281 310.753 90.8964 311.049 90.8964 311.587Z",
    fill: "#A6A6A6"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3739 311.318C90.3739 312.071 89.8641 312.958 89.2202 313.335C89.0592 313.442 88.8714 313.496 88.7372 313.496C88.6567 313.361 88.603 313.173 88.603 312.931C88.603 312.178 89.1128 311.291 89.7568 310.914C89.9178 310.807 90.1056 310.753 90.2398 310.753C90.3202 310.887 90.3739 311.076 90.3739 311.318Z",
    fill: "#4A4A4A"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M103.332 302.628L102.339 302.117C101.936 301.928 101.399 301.982 100.808 302.332C99.5198 303.085 98.4728 304.888 98.4728 306.368C98.4728 307.148 98.7681 307.686 99.2245 307.902L99.8957 308.225L100.057 307.982C100.298 307.929 100.54 307.848 100.782 307.686C102.07 306.933 103.117 305.13 103.117 303.65C103.117 303.435 103.117 303.22 103.064 303.058L103.332 302.601V302.628Z",
    fill: "#A6A6A6"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M103.895 304.055C103.895 305.535 102.848 307.337 101.559 308.091C100.271 308.844 99.2235 308.225 99.2235 306.745C99.2235 305.266 100.271 303.463 101.559 302.709C102.848 301.956 103.895 302.575 103.895 304.055Z",
    fill: "#5C5C5C"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M102.739 304.724C102.739 305.477 102.23 306.365 101.586 306.741C101.156 306.983 100.754 306.929 100.566 306.634C100.727 306.634 100.888 306.58 101.049 306.472C101.693 306.096 102.203 305.208 102.203 304.455C102.203 304.213 102.149 304.025 102.069 303.891C102.471 303.891 102.739 304.186 102.739 304.724Z",
    fill: "#A6A6A6"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M102.209 304.455C102.209 305.208 101.699 306.096 101.055 306.472C100.894 306.58 100.707 306.634 100.572 306.634C100.492 306.499 100.438 306.311 100.438 306.069C100.438 305.316 100.948 304.428 101.592 304.052C101.78 303.944 101.941 303.918 102.075 303.891C102.155 304.025 102.209 304.213 102.209 304.455Z",
    fill: "#4A4A4A"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M115.184 295.786L114.19 295.275C113.788 295.087 113.251 295.14 112.66 295.49C111.371 296.217 110.351 298.046 110.351 299.526C110.351 300.306 110.647 300.845 111.103 301.087L111.774 301.41L111.935 301.167C112.177 301.114 112.418 301.033 112.66 300.871C113.949 300.118 114.996 298.315 114.996 296.835C114.996 296.62 114.969 296.405 114.915 296.244L115.184 295.786Z",
    fill: "#A6A6A6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M115.754 297.215C115.754 298.695 114.707 300.498 113.418 301.251C112.13 302.004 111.083 301.385 111.083 299.906C111.083 298.426 112.13 296.596 113.418 295.87C114.707 295.116 115.754 295.735 115.754 297.215Z",
    fill: "#5C5C5C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M114.567 297.884C114.567 298.637 114.057 299.525 113.414 299.901C112.984 300.143 112.582 300.09 112.394 299.794C112.555 299.794 112.716 299.74 112.877 299.632C113.521 299.256 114.031 298.368 114.031 297.616C114.031 297.373 113.977 297.185 113.896 297.051C114.299 297.051 114.567 297.347 114.567 297.884Z",
    fill: "#A6A6A6"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M114.025 297.616C114.025 298.368 113.515 299.256 112.872 299.632C112.711 299.74 112.523 299.794 112.389 299.794C112.308 299.659 112.254 299.471 112.254 299.229C112.254 298.476 112.764 297.589 113.408 297.212C113.569 297.105 113.757 297.051 113.891 297.051C113.972 297.185 114.025 297.373 114.025 297.616Z",
    fill: "#4A4A4A"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M127.006 288.925L126.013 288.414C125.61 288.225 125.073 288.306 124.483 288.629C123.194 289.382 122.147 291.185 122.147 292.665C122.147 293.445 122.442 293.983 122.899 294.225L123.57 294.548L123.731 294.306C123.972 294.252 124.214 294.172 124.456 294.01C125.744 293.257 126.791 291.454 126.791 289.974C126.791 289.759 126.791 289.544 126.711 289.382L126.979 288.925H127.006Z",
    fill: "#A6A6A6"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M127.566 290.347C127.566 291.827 126.519 293.629 125.231 294.383C123.942 295.136 122.895 294.517 122.895 293.037C122.895 291.558 123.942 289.755 125.231 289.001C126.519 288.248 127.566 288.867 127.566 290.347Z",
    fill: "#5C5C5C"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M126.39 291.027C126.39 291.78 125.88 292.667 125.236 293.044C124.807 293.286 124.404 293.232 124.216 292.936C124.35 292.936 124.538 292.883 124.699 292.775C125.343 292.398 125.853 291.511 125.853 290.758C125.853 290.516 125.799 290.328 125.719 290.193C126.121 290.193 126.39 290.489 126.39 291.027Z",
    fill: "#A6A6A6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M125.845 290.758C125.845 291.511 125.335 292.398 124.691 292.775C124.53 292.883 124.343 292.936 124.208 292.936C124.128 292.802 124.074 292.614 124.074 292.372C124.074 291.619 124.584 290.731 125.228 290.355C125.389 290.247 125.577 290.193 125.711 290.193C125.791 290.328 125.845 290.516 125.845 290.758Z",
    fill: "#4A4A4A"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M138.821 282.091L137.827 281.58C137.425 281.391 136.888 281.445 136.297 281.795C135.009 282.548 133.962 284.351 133.962 285.831C133.962 286.611 134.257 287.149 134.74 287.391L135.411 287.714L135.572 287.472C135.814 287.418 136.056 287.338 136.297 287.176C137.586 286.423 138.633 284.62 138.633 283.14C138.633 282.925 138.633 282.71 138.552 282.548L138.821 282.091Z",
    fill: "#A6A6A6"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M139.381 283.518C139.381 284.998 138.334 286.8 137.045 287.554C135.757 288.307 134.736 287.688 134.736 286.208C134.736 284.728 135.783 282.926 137.045 282.172C138.334 281.419 139.381 282.038 139.381 283.518Z",
    fill: "#5C5C5C"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M138.228 284.189C138.228 284.942 137.718 285.829 137.074 286.206C136.645 286.448 136.243 286.394 136.055 286.098C136.189 286.098 136.377 286.045 136.538 285.937C137.182 285.561 137.692 284.673 137.692 283.92C137.692 283.678 137.638 283.49 137.557 283.355C137.96 283.355 138.228 283.651 138.228 284.189Z",
    fill: "#A6A6A6"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M137.7 283.92C137.7 284.673 137.191 285.561 136.547 285.937C136.386 286.045 136.198 286.098 136.064 286.098C135.983 285.964 135.93 285.776 135.93 285.534C135.93 284.781 136.439 283.893 137.083 283.517C137.271 283.409 137.432 283.355 137.566 283.355C137.647 283.49 137.7 283.678 137.7 283.92Z",
    fill: "#4A4A4A"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M150.651 275.227L149.658 274.715C149.255 274.527 148.718 274.581 148.127 274.931C146.839 275.684 145.792 277.487 145.792 278.967C145.792 279.747 146.087 280.285 146.543 280.5L147.215 280.85L147.376 280.608C147.617 280.554 147.859 280.473 148.127 280.312C149.416 279.559 150.463 277.756 150.463 276.276C150.463 276.061 150.463 275.845 150.382 275.684L150.651 275.227Z",
    fill: "#A6A6A6"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 276.656C151.211 278.136 150.164 279.939 148.875 280.692C147.587 281.446 146.54 280.827 146.54 279.347C146.54 277.867 147.587 276.064 148.875 275.311C150.164 274.558 151.211 275.176 151.211 276.656Z",
    fill: "#5C5C5C"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M150.056 277.325C150.056 278.078 149.546 278.965 148.902 279.342C148.473 279.584 148.07 279.53 147.882 279.234C148.016 279.234 148.204 279.18 148.365 279.073C149.009 278.696 149.519 277.809 149.519 277.056C149.519 276.814 149.465 276.626 149.385 276.491C149.787 276.491 150.056 276.787 150.056 277.325Z",
    fill: "#A6A6A6"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M149.528 277.056C149.528 277.809 149.019 278.696 148.375 279.073C148.187 279.18 148.026 279.234 147.892 279.234C147.811 279.1 147.757 278.911 147.757 278.669C147.757 277.916 148.267 277.029 148.911 276.653C149.072 276.545 149.26 276.491 149.394 276.491C149.475 276.626 149.528 276.814 149.528 277.056Z",
    fill: "#4A4A4A"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 268.391L161.507 267.879C161.104 267.691 160.567 267.772 159.976 268.095C158.688 268.821 157.641 270.651 157.641 272.131C157.641 272.911 157.936 273.449 158.392 273.664L159.064 273.987L159.225 273.745C159.466 273.691 159.708 273.611 159.95 273.449C161.238 272.696 162.285 270.893 162.285 269.413C162.285 269.198 162.285 268.983 162.205 268.821L162.473 268.364L162.5 268.391Z",
    fill: "#A6A6A6"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M163.06 269.815C163.06 271.294 162.013 273.097 160.724 273.851C159.436 274.604 158.389 273.985 158.389 272.505C158.389 271.025 159.436 269.223 160.724 268.469C162.013 267.716 163.06 268.335 163.06 269.815Z",
    fill: "#5C5C5C"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M161.907 270.459C161.907 271.212 161.397 272.099 160.753 272.476C160.324 272.718 159.922 272.664 159.734 272.368C159.868 272.368 160.029 272.314 160.217 272.207C160.861 271.83 161.371 270.943 161.371 270.19C161.371 269.948 161.317 269.759 161.236 269.625C161.639 269.625 161.907 269.921 161.907 270.459Z",
    fill: "#A6A6A6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M161.38 270.19C161.38 270.943 160.87 271.83 160.226 272.207C160.038 272.314 159.877 272.368 159.743 272.368C159.663 272.234 159.609 272.045 159.609 271.803C159.609 271.05 160.119 270.163 160.763 269.786C160.924 269.679 161.112 269.625 161.246 269.625C161.326 269.759 161.38 269.948 161.38 270.19Z",
    fill: "#4A4A4A"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M174.348 261.535L173.354 261.024C172.952 260.836 172.415 260.889 171.824 261.239C170.535 261.993 169.488 263.795 169.488 265.275C169.488 266.055 169.784 266.594 170.267 266.836L170.938 267.159L171.099 266.917C171.341 266.863 171.582 266.782 171.824 266.621C173.113 265.867 174.16 264.064 174.16 262.584C174.16 262.369 174.16 262.154 174.079 261.993L174.348 261.535Z",
    fill: "#A6A6A6"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M174.908 262.964C174.908 264.444 173.861 266.247 172.573 267C171.284 267.753 170.237 267.135 170.264 265.655C170.264 264.175 171.311 262.372 172.573 261.619C173.861 260.865 174.908 261.484 174.908 262.964Z",
    fill: "#5C5C5C"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M173.755 263.633C173.755 264.36 173.245 265.274 172.601 265.65C172.172 265.892 171.769 265.839 171.582 265.543C171.743 265.543 171.904 265.489 172.065 265.381C172.709 265.005 173.218 264.117 173.218 263.365C173.218 263.123 173.165 262.934 173.084 262.8C173.487 262.8 173.755 263.096 173.755 263.633Z",
    fill: "#A6A6A6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M173.227 263.365C173.227 264.117 172.717 265.005 172.074 265.381C171.913 265.489 171.725 265.543 171.591 265.543C171.51 265.408 171.456 265.22 171.456 264.978C171.456 264.225 171.966 263.338 172.61 262.961C172.798 262.854 172.959 262.8 173.093 262.8C173.174 262.934 173.227 263.123 173.227 263.365Z",
    fill: "#4A4A4A"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M186.176 254.698L185.183 254.187C184.78 253.999 184.243 254.052 183.653 254.402C182.364 255.156 181.317 256.958 181.317 258.438C181.317 259.219 181.612 259.757 182.069 259.972L182.74 260.322L182.901 260.08C183.143 260.026 183.384 259.945 183.653 259.784C184.941 259.03 185.988 257.227 185.988 255.748C185.988 255.532 185.962 255.317 185.908 255.156L186.176 254.698Z",
    fill: "#A6A6A6"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M186.737 256.125C186.737 257.605 185.689 259.408 184.401 260.161C183.112 260.914 182.065 260.296 182.065 258.816C182.065 257.336 183.112 255.533 184.401 254.78C185.689 254.026 186.737 254.645 186.737 256.125Z",
    fill: "#5C5C5C"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M185.584 256.765C185.584 257.518 185.074 258.406 184.43 258.782C184.001 259.024 183.598 258.97 183.41 258.675C183.544 258.675 183.732 258.621 183.893 258.513C184.537 258.137 185.047 257.249 185.047 256.496C185.047 256.281 184.993 256.066 184.913 255.932C185.315 255.932 185.584 256.227 185.584 256.765Z",
    fill: "#A6A6A6"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M185.015 256.496C185.015 257.249 184.505 258.137 183.862 258.513C183.674 258.621 183.513 258.675 183.379 258.675C183.298 258.54 183.244 258.352 183.244 258.11C183.244 257.384 183.781 256.469 184.398 256.093C184.559 255.985 184.747 255.932 184.881 255.932C184.962 256.066 185.015 256.254 185.015 256.496Z",
    fill: "#4A4A4A"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M198.03 247.84L197.036 247.329C196.634 247.14 196.097 247.194 195.506 247.544C194.218 248.297 193.171 250.1 193.171 251.58C193.171 252.36 193.466 252.898 193.922 253.114L194.593 253.463L194.754 253.221C194.996 253.167 195.238 253.087 195.506 252.925C196.795 252.172 197.842 250.369 197.842 248.889C197.842 248.674 197.815 248.459 197.761 248.297L198.03 247.84Z",
    fill: "#A6A6A6"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M198.59 249.267C198.59 250.747 197.543 252.549 196.254 253.303C194.966 254.056 193.919 253.437 193.919 251.957C193.919 250.477 194.966 248.675 196.254 247.921C197.543 247.168 198.59 247.787 198.59 249.267Z",
    fill: "#5C5C5C"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M197.413 249.938C197.413 250.691 196.903 251.579 196.259 251.955C195.83 252.197 195.427 252.143 195.24 251.847C195.374 251.847 195.562 251.794 195.723 251.686C196.367 251.31 196.876 250.422 196.876 249.669C196.876 249.454 196.823 249.239 196.742 249.104C197.145 249.104 197.413 249.4 197.413 249.938Z",
    fill: "#A6A6A6"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M196.871 249.667C196.871 250.42 196.361 251.308 195.717 251.684C195.529 251.792 195.368 251.845 195.234 251.845C195.154 251.711 195.1 251.523 195.1 251.281C195.1 250.555 195.61 249.64 196.254 249.264C196.415 249.156 196.603 249.103 196.737 249.103C196.817 249.237 196.871 249.425 196.871 249.667Z",
    fill: "#4A4A4A"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4254 322.424L196.317 245.523L201.982 255.721V313.733L57.7607 397.171L57.7876 339.16L63.4254 322.424Z",
    fill: "url(#paint24_linear_1487_155510)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3694 321.616V323.338L100.565 314.512V304.987L99.4103 305.66V313.49L85.3694 321.616Z",
    fill: "#344054"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3694 313.814V321.617L99.4103 313.491V305.661L85.3694 313.814Z",
    fill: "url(#paint25_linear_1487_155510)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1064 335.61L81.9327 325.304V315.779L80.7783 316.452V324.255L64.9655 333.403L64.1064 335.61Z",
    fill: "#344054"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9583 333.399L80.771 324.25V316.447L68.7705 323.389L64.9583 333.399Z",
    fill: "url(#paint26_linear_1487_155510)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M178.628 267.644V269.339L196.427 259.034L191.783 252.227L191.434 252.415L195.273 258.012L178.628 267.644Z",
    fill: "#344054"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M178.628 259.842V267.645L195.273 258.013L191.434 252.416L178.628 259.842Z",
    fill: "url(#paint27_linear_1487_155510)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M103.997 310.827V312.549L119.193 303.751V294.226L118.038 294.898V302.701L103.997 310.827Z",
    fill: "#344054"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M103.997 303.022V310.825L118.038 302.699V294.896L103.997 303.022Z",
    fill: "url(#paint28_linear_1487_155510)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M122.606 300.039V301.761L137.828 292.963V283.438L136.674 284.11V291.913L122.606 300.039Z",
    fill: "#344054"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M122.606 292.233V300.036L136.674 291.91V284.107L122.606 292.233Z",
    fill: "url(#paint29_linear_1487_155510)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M141.244 289.25V290.972L156.466 282.173V272.648L155.312 273.321V281.124L141.244 289.25Z",
    fill: "#344054"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M141.244 281.446V289.249L155.312 281.123V273.32L141.244 281.446Z",
    fill: "url(#paint30_linear_1487_155510)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M159.863 278.488V280.21L175.085 271.411V261.859L173.931 262.532V270.362L159.863 278.488Z",
    fill: "#344054"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M159.863 270.685V278.488L173.931 270.362V262.532L159.863 270.685Z",
    fill: "url(#paint31_linear_1487_155510)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4203 320.676L63.4271 322.425L57.7893 339.161L54.7556 337.412L60.4203 320.676Z",
    fill: "url(#paint32_linear_1487_155510)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4147 320.674L193.306 243.774L196.313 245.523L63.4215 322.423L60.4147 320.674Z",
    fill: "url(#paint33_linear_1487_155510)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M137.875 178.344V202.372L170.816 183.322V159.294L143.593 143.526L137.875 178.344Z",
    fill: "url(#paint34_linear_1487_155510)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M110.657 219.512L137.88 202.372V178.344L170.821 159.294L143.598 143.526L110.657 162.603V219.512Z",
    fill: "url(#paint35_linear_1487_155510)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M140.105 170.132L123.111 160.311V140.642L142.119 129.637L159.113 139.458L140.105 150.463V170.132Z",
    fill: "url(#paint36_linear_1487_155510)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M140.105 170.132L123.111 160.311V140.642L142.119 129.637L159.113 139.458L140.105 150.463V170.132Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M159.116 159.161L140.108 170.139V150.47L159.116 139.465V159.161Z",
    fill: "url(#paint37_linear_1487_155510)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M150.373 133.604V139.066C150.373 140.438 149.46 141.81 147.661 142.86C144.037 144.958 138.131 144.958 134.506 142.86C132.681 141.81 131.795 140.438 131.795 139.066V133.604H150.4H150.373Z",
    fill: "#363636"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M150.373 133.604V139.066C150.373 140.438 149.46 141.81 147.661 142.86C144.037 144.958 138.131 144.958 134.506 142.86C132.681 141.81 131.795 140.438 131.795 139.066V133.604H150.4H150.373Z",
    fill: "url(#paint38_linear_1487_155510)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M134.513 137.394C138.137 139.493 144.044 139.493 147.668 137.394C151.292 135.295 151.292 131.878 147.668 129.779C144.044 127.68 138.137 127.68 134.513 129.779C130.889 131.878 130.889 135.295 134.513 137.394Z",
    fill: "#5C5C5C"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M149.362 115.058V133.112C149.362 134.35 148.557 135.561 146.946 136.502C143.725 138.359 138.463 138.359 135.241 136.502C133.63 135.561 132.825 134.35 132.825 133.112V115.058H149.389H149.362Z",
    fill: "#363636"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M149.362 115.058V133.112C149.362 134.35 148.557 135.561 146.946 136.502C143.725 138.359 138.463 138.359 135.241 136.502C133.63 135.561 132.825 134.35 132.825 133.112V115.058H149.389H149.362Z",
    fill: "url(#paint39_linear_1487_155510)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M135.241 118.45C138.463 120.334 143.725 120.334 146.946 118.45C150.168 116.594 150.168 113.553 146.946 111.67C143.725 109.813 138.463 109.813 135.241 111.67C132.019 113.553 132.019 116.567 135.241 118.45Z",
    fill: "url(#paint40_linear_1487_155510)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M181.793 130.663L144.53 152.242L140.127 144.628L177.39 123.075L181.793 130.663Z",
    fill: "#98A2B3"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M172.672 135.936L168.135 138.573L167.061 129.074L171.598 126.438L172.672 135.936Z",
    fill: "#232323"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M163.474 141.268L158.936 143.905L157.836 134.38L162.373 131.77L163.474 141.268Z",
    fill: "#232323"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M154.306 146.59L149.769 149.199L148.668 139.701L153.205 137.064L154.306 146.59Z",
    fill: "#232323"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M146.613 147.608C146.613 148.55 145.969 148.926 145.163 148.442C144.358 147.985 143.714 146.855 143.714 145.913C143.714 144.972 144.358 144.595 145.163 145.08C145.969 145.537 146.613 146.667 146.613 147.608Z",
    fill: "#363636"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M177.926 129.504C177.926 130.445 177.282 130.822 176.477 130.338C175.672 129.88 175.027 128.75 175.027 127.809C175.027 126.867 175.672 126.491 176.477 126.975C177.282 127.432 177.926 128.562 177.926 129.504Z",
    fill: "#363636"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M180.789 121.071L177.373 123.052L181.756 130.644L185.172 128.664L180.789 121.071Z",
    fill: "#D0D5DD"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M173.263 214.101V225.428C173.263 225.751 173.048 226.074 172.619 226.316C171.787 226.801 170.417 226.801 169.558 226.316C169.129 226.074 168.914 225.751 168.914 225.428V214.101H173.236H173.263Z",
    fill: "url(#paint41_linear_1487_155510)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M169.556 214.989C170.388 215.473 171.756 215.473 172.615 214.989C173.447 214.505 173.447 213.698 172.615 213.214C171.783 212.73 170.414 212.73 169.556 213.214C168.697 213.698 168.723 214.505 169.556 214.989Z",
    fill: "#5C5C5C"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M177.442 211.982V213.812H177.416C177.416 214.754 176.798 215.696 175.563 216.395C173.093 217.821 169.093 217.821 166.623 216.395C165.388 215.669 164.771 214.754 164.771 213.812V211.982H177.469H177.442Z",
    fill: "#D0D5DD"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M166.599 214.592C169.069 216.018 173.069 216.018 175.539 214.592C178.009 213.166 178.009 210.852 175.539 209.426C173.069 208 169.069 208 166.599 209.426C164.129 210.852 164.129 213.166 166.599 214.592Z",
    fill: "url(#paint42_linear_1487_155510)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M175.697 197.579V211.598C175.697 212.27 175.24 212.97 174.354 213.481C172.556 214.53 169.656 214.53 167.857 213.481C166.971 212.97 166.515 212.27 166.515 211.598V197.579H175.723H175.697Z",
    fill: "url(#paint43_linear_1487_155510)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M167.84 199.465C169.639 200.514 172.538 200.514 174.337 199.465C176.136 198.415 176.136 196.747 174.337 195.725C172.538 194.675 169.639 194.675 167.84 195.725C166.042 196.747 166.042 198.442 167.84 199.465Z",
    fill: "#5C5C5C"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M180.874 196.936V199.761H180.82C180.82 201.214 179.853 202.64 177.974 203.743C174.162 205.949 167.987 205.949 164.175 203.743C162.269 202.64 161.329 201.187 161.329 199.761V196.936H180.9H180.874Z",
    fill: "#D0D5DD"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M164.155 200.917C167.967 203.123 174.142 203.123 177.954 200.917C181.766 198.71 181.766 195.132 177.954 192.925C174.142 190.719 167.967 190.719 164.155 192.925C160.342 195.132 160.342 198.71 164.155 200.917Z",
    fill: "url(#paint44_linear_1487_155510)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M178.418 180.261V196.243H178.391C178.391 197.32 177.666 198.423 176.244 199.257C173.371 200.898 168.726 200.898 165.881 199.257C164.458 198.423 163.733 197.347 163.733 196.243V180.261H178.445H178.418Z",
    fill: "url(#paint45_linear_1487_155510)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M165.887 183.246C168.76 184.887 173.404 184.887 176.25 183.246C179.123 181.577 179.123 178.914 176.25 177.245C173.378 175.577 168.733 175.577 165.887 177.245C163.015 178.887 163.015 181.577 165.887 183.246Z",
    fill: "#5C5C5C"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M183.455 175.226V178.804H183.402C183.402 180.634 182.194 182.464 179.777 183.863C174.972 186.634 167.133 186.634 162.327 183.863C159.911 182.464 158.703 180.634 158.703 178.804V175.226H183.455Z",
    fill: "#D0D5DD"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M162.324 180.282C167.13 183.08 174.969 183.08 179.775 180.282C184.58 177.483 184.58 172.963 179.775 170.192C174.969 167.393 167.13 167.393 162.324 170.192C157.492 172.963 157.519 177.51 162.324 180.282Z",
    fill: "#98A2B3"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M180.697 153.398V174.278H180.643C180.643 175.704 179.704 177.103 177.824 178.207C174.093 180.359 168.025 180.359 164.267 178.207C162.387 177.13 161.448 175.704 161.448 174.278V153.398H180.643H180.697Z",
    fill: "url(#paint46_linear_1487_155510)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M164.28 157.297C168.012 159.476 174.079 159.476 177.838 157.297C181.57 155.144 181.57 151.619 177.838 149.467C174.106 147.287 168.039 147.287 164.28 149.467C160.549 151.619 160.549 155.144 164.28 157.297Z",
    fill: "#98A2B3"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M179.188 150.58V152.921H179.134C179.134 154.105 178.356 155.316 176.772 156.231C173.604 158.06 168.503 158.06 165.335 156.231C163.751 155.316 162.973 154.132 162.973 152.921V150.58H179.188Z",
    fill: "#D0D5DD"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M165.356 153.887C168.523 155.717 173.624 155.717 176.792 153.887C179.96 152.057 179.96 149.097 176.792 147.268C173.624 145.438 168.523 145.438 165.356 147.268C162.188 149.097 162.188 152.057 165.356 153.887Z",
    fill: "#98A2B3"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M175.619 137.068V150.307C175.619 150.979 175.189 151.652 174.276 152.163C172.504 153.186 169.632 153.186 167.86 152.163C166.974 151.652 166.518 150.979 166.518 150.307V137.068H175.592H175.619Z",
    fill: "#363636"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M167.853 138.953C169.625 139.975 172.498 139.975 174.27 138.953C176.042 137.93 176.042 136.262 174.27 135.24C172.498 134.217 169.625 134.217 167.853 135.24C166.082 136.262 166.082 137.93 167.853 138.953Z",
    fill: "#5C5C5C"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M180.874 136.831V139.656H180.82C180.82 141.109 179.853 142.535 177.974 143.639C174.162 145.845 167.987 145.845 164.175 143.639C162.269 142.535 161.329 141.082 161.329 139.656V136.831H180.9H180.874Z",
    fill: "#D0D5DD"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M164.155 140.814C167.967 143.02 174.142 143.02 177.954 140.814C181.766 138.608 181.766 135.029 177.954 132.823C174.142 130.616 167.967 130.616 164.155 132.823C160.342 135.029 160.342 138.608 164.155 140.814Z",
    fill: "#98A2B3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M170.242 145.483L158.832 138.864V125.679L171.584 118.307L182.994 124.899L170.242 132.271V145.483Z",
    fill: "#7F56D9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M183.001 138.081L170.249 145.48V132.269L183.001 124.896V138.081Z",
    fill: "#D0D5DD"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M164.367 130.625L127.097 152.19L131.473 159.787L168.743 138.221L164.367 130.625Z",
    fill: "#98A2B3"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M159.604 143.491L155.067 146.128L153.993 136.63L158.53 133.993L159.604 143.491Z",
    fill: "#232323"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M150.417 148.823L145.88 151.46L144.78 141.935L149.317 139.325L150.417 148.823Z",
    fill: "#232323"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M141.226 154.153L136.689 156.763L135.588 147.265L140.125 144.628L141.226 154.153Z",
    fill: "#232323"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M133.545 155.168C133.545 156.109 132.901 156.486 132.096 156.002C131.29 155.544 130.646 154.415 130.646 153.473C130.646 152.532 131.29 152.155 132.096 152.639C132.901 153.096 133.545 154.226 133.545 155.168Z",
    fill: "#363636"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M164.861 137.062C164.861 137.977 164.216 138.38 163.411 137.896C162.606 137.439 161.962 136.309 161.962 135.368C161.962 134.426 162.606 134.049 163.411 134.534C164.216 134.991 164.861 136.148 164.861 137.062Z",
    fill: "#363636"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M167.754 128.657L164.337 130.637L168.717 138.231L172.134 136.251L167.754 128.657Z",
    fill: "#D0D5DD"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1487_155510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4186 57.9526C101.379 56.3195 103.85 55.4252 106.402 55.4252C108.954 55.4252 111.425 56.3195 113.386 57.9526M95.8673 54.4311C98.7663 51.8757 102.498 50.4658 106.362 50.4658C110.227 50.4658 113.959 51.8757 116.858 54.4311M102.92 61.4841C103.927 60.7686 105.132 60.3842 106.367 60.3842C107.603 60.3842 108.807 60.7686 109.814 61.4841M106.362 65.3428H106.372",
    stroke: "#FCFAFF",
    strokeWidth: 1.98395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.7513 118.789C84.8303 118.047 93.755 118.803 104.312 124.188L104.923 122.991C94.1298 117.485 84.936 116.68 78.5885 117.454C75.4207 117.841 72.9498 118.623 71.34 119.42C70.5437 119.815 69.9166 120.233 69.5262 120.641C69.3356 120.84 69.1521 121.087 69.0731 121.374C68.9824 121.704 69.0393 122.078 69.3229 122.362L70.2738 121.412C70.3802 121.518 70.3872 121.665 70.3692 121.731C70.3683 121.734 70.3678 121.735 70.3679 121.736C70.3687 121.736 70.3924 121.68 70.4972 121.571C70.7329 121.324 71.203 120.988 71.9366 120.625C73.3865 119.906 75.7058 119.16 78.7513 118.789Z",
    fill: "url(#paint47_linear_1487_155510)",
    stroke: "#1D2939",
    strokeWidth: 0.2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1487_155510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.331 127.316C109.803 127.31 107.719 126.702 106.344 124.391C106.074 123.965 105.596 122.872 105.433 121.392C104.73 122.663 103.109 125.608 102.249 127.216C101.388 128.824 102.086 130.421 102.542 131.018C102.431 131.058 102.33 131.098 102.238 131.138C102.063 130.847 101.841 130.326 101.721 129.682C101.723 129.812 101.727 130.179 101.727 130.605C101.727 131.031 101.995 131.171 102.129 131.188C101.575 131.454 101.399 131.723 101.376 131.9C101.373 131.928 101.373 131.954 101.376 131.977V132.595C101.37 132.606 101.388 132.643 101.51 132.704C101.631 132.764 102.944 133.529 103.78 133.877C105.501 134.464 110.119 135.381 114.829 134.355C115.858 134.145 117.921 133.542 117.948 132.812L117.922 132.19C117.923 132.165 117.922 132.141 117.919 132.117C117.883 131.774 117.539 131.474 117.23 131.301C116.926 131.181 116.072 130.844 115.09 130.453C114.108 130.062 112.132 129.314 111.603 129.089C111.085 128.582 111.295 127.84 111.331 127.316Z",
    fill: "#D0D5DD"
  }))), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 131.138C102.33 131.098 102.431 131.058 102.542 131.018C102.086 130.421 101.388 128.824 102.249 127.216C103.109 125.608 104.73 122.663 105.433 121.392C105.596 122.872 106.074 123.965 106.344 124.391C107.719 126.702 109.803 127.31 111.331 127.316C111.295 127.84 111.085 128.582 111.603 129.089C112.132 129.314 114.108 130.062 115.09 130.453C116.072 130.844 116.926 131.181 117.23 131.301C117.539 131.474 117.883 131.774 117.919 132.117M102.238 131.138C102.2 131.155 102.164 131.172 102.129 131.188M102.238 131.138C102.063 130.847 101.841 130.326 101.721 129.682M105.269 120.99L101.912 127.216C101.582 128.091 101.588 128.963 101.721 129.682M102.129 131.188C101.995 131.171 101.727 131.031 101.727 130.605C101.727 130.179 101.723 129.812 101.721 129.682M102.129 131.188C101.575 131.454 101.399 131.723 101.376 131.9M101.376 131.9C101.37 131.951 101.376 131.995 101.39 132.029C101.876 132.416 103.374 133.298 105.486 133.723C107.598 134.149 109.263 134.191 109.832 134.158C111.309 134.129 114.749 133.899 116.687 133.213C117.669 132.865 117.957 132.469 117.919 132.117M101.376 131.9V132.595C101.37 132.606 101.388 132.643 101.51 132.704C101.631 132.764 102.944 133.529 103.78 133.877C105.501 134.464 110.119 135.381 114.829 134.355C115.858 134.145 117.921 133.542 117.948 132.812L117.919 132.117",
    stroke: "#98A2B3",
    strokeWidth: 0.370537
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M105.323 89.0466V120.184C105.314 120.616 105.336 121.027 105.378 121.412C105.542 122.892 106.02 123.985 106.29 124.41C107.665 126.721 109.748 127.33 111.277 127.335C111.806 127.337 112.269 127.267 112.613 127.17C116.542 125.971 117.806 122.238 117.948 120.521V89.7093C117.139 84.0076 113.055 82.843 111.114 82.9733C106.846 83.2602 105.475 87.1417 105.323 89.0466Z",
    fill: "#F04438"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M105.323 120.184V89.0466C105.475 87.1417 106.846 83.2602 111.114 82.9733C113.055 82.843 117.139 84.0076 117.948 89.7093V120.521C117.806 122.238 116.542 125.971 112.613 127.17C112.269 127.267 111.806 127.337 111.277 127.335C109.748 127.33 107.665 126.721 106.29 124.41C106.02 123.985 105.542 122.892 105.378 121.412C105.336 121.027 105.314 120.616 105.323 120.184ZM105.323 120.184L105.215 121.01",
    stroke: "#D0D5DD",
    strokeWidth: 0.370537
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M112.771 126.119C116.465 125.632 117.686 122.113 117.834 120.415C117.983 118.717 117.943 89.875 117.943 89.875C117.36 85.3814 114.419 84.1277 113.021 84.0625C108.936 84.1581 107.879 87.7021 107.861 89.4621V121.067C108.269 125.404 111.305 126.242 112.771 126.119Z",
    fill: "#F2F4F7",
    stroke: "#98A2B3",
    strokeWidth: 0.370537
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M111.78 120.873C111.78 121.365 111.921 121.827 112.169 122.165C112.416 122.503 112.767 122.716 113.19 122.716C113.614 122.716 114.025 122.501 114.332 122.162C114.638 121.822 114.836 121.361 114.836 120.873C114.836 119.888 114.271 119.128 113.426 119.128C112.572 119.128 111.78 119.897 111.78 120.873Z",
    fill: "#FCFCFD",
    stroke: "#373737",
    strokeWidth: 0.0926342
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M114.646 119.92C114.325 119.138 113.607 118.986 113.289 119.008C112.384 119.008 111.549 119.83 111.549 120.868C111.549 121.907 112.141 122.831 113.046 122.831C113.272 122.824 113.825 122.703 114.233 122.277",
    stroke: "#373737",
    strokeWidth: 0.0741074
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M112.276 120.9C112.276 121.254 112.378 121.587 112.556 121.829C112.733 122.072 112.984 122.223 113.286 122.223C113.589 122.223 113.884 122.07 114.104 121.826C114.324 121.582 114.466 121.25 114.466 120.9C114.466 120.191 114.06 119.649 113.457 119.649C112.846 119.649 112.276 120.2 112.276 120.9Z",
    stroke: "#373737",
    strokeWidth: 0.0901269
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M112.242 120.903C112.242 121.272 112.348 121.617 112.531 121.868C112.713 122.116 112.969 122.27 113.274 122.27C113.583 122.27 113.886 122.113 114.114 121.86C114.342 121.607 114.489 121.264 114.489 120.903C114.489 120.16 114.066 119.612 113.457 119.612C112.83 119.612 112.242 120.179 112.242 120.903Z",
    stroke: "#373737",
    strokeWidth: 0.185268
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M112.544 120.905C112.544 121.173 112.621 121.423 112.754 121.606C112.887 121.788 113.075 121.901 113.301 121.901C113.528 121.901 113.75 121.786 113.915 121.602C114.081 121.418 114.188 121.169 114.188 120.905C114.188 120.368 113.882 119.963 113.431 119.963C112.972 119.963 112.544 120.378 112.544 120.905Z",
    fill: "#7F56D9",
    stroke: "#373737",
    strokeWidth: 0.0926342
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M101.046 93.335L103.351 95.0895",
    stroke: "#F04438",
    strokeWidth: 0.259264
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M100.802 98.3291L103.394 96.6084",
    stroke: "#F04438",
    strokeWidth: 0.259264
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M103.42 93.3338L99.0873 88.1508",
    stroke: "#F04438",
    strokeWidth: 0.518528
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M103.91 95.8304L96.9242 95.8294",
    stroke: "#F04438",
    strokeWidth: 0.518528
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M103.781 97.9912L99.5132 102.294",
    stroke: "#F04438",
    strokeWidth: 0.518528
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1487_155510",
    x: 301.452,
    y: 158.981,
    width: 17.632,
    height: 15.4733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.74472
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34309
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.980392 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1487_155510"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1487_155510",
    x: 300.537,
    y: 120.112,
    width: 14.5486,
    height: 47.4715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.60109,
    dy: 0.914907
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.457453
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196039 0 0 0 0 0.835333 0 0 0 0 0.515686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1487_155510"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1487_155510",
    x: 101.189,
    y: 120.133,
    width: 16.9446,
    height: 14.8704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.63774
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.329717
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.980392 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1487_155510"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1487_155510",
    x1: 270,
    y1: 172,
    x2: 335,
    y2: 345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53389E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F56D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1487_155510",
    x1: 301.5,
    y1: 152,
    x2: 328.043,
    y2: 267.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558979,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1487_155510",
    x1: 475.5,
    y1: 331,
    x2: 437,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558979,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1487_155510",
    x1: 355,
    y1: 260,
    x2: 437,
    y2: 353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1487_155510",
    x1: 356.5,
    y1: 258,
    x2: 436.5,
    y2: 348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1487_155510",
    x1: 317,
    y1: 287,
    x2: 392.5,
    y2: 378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E77ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1487_155510",
    x1: 366.5,
    y1: 263,
    x2: 367.492,
    y2: 306.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53389E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#7F56D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1487_155510",
    x1: 433.5,
    y1: 294.5,
    x2: 437,
    y2: 340,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E77ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1487_155510",
    x1: 467.191,
    y1: 265.059,
    x2: 423.336,
    y2: 336.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558979,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1487_155510",
    x1: 428.5,
    y1: 274,
    x2: 428.5,
    y2: 291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEAFB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1487_155510",
    x1: 459,
    y1: 248,
    x2: 450,
    y2: 288.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1487_155510",
    x1: 147,
    y1: 138,
    x2: 107,
    y2: 254.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1487_155510",
    x1: 101.582,
    y1: 106.334,
    x2: 59.5,
    y2: 282.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42307D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359937,
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975351,
    stopColor: "#7F56D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1487_155510",
    x1: 26.8534,
    y1: 301.525,
    x2: 23.8622,
    y2: 319.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42307D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1487_155510",
    x1: 159.5,
    y1: 224.5,
    x2: 30,
    y2: 303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1487_155510",
    x1: 43.5,
    y1: 327.5,
    x2: 33.5,
    y2: 383.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42307D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E77ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1487_155510",
    x1: 58.4029,
    y1: 285.902,
    x2: 58.4029,
    y2: 301.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1487_155510",
    x1: 38.8799,
    y1: 296.697,
    x2: 38.8799,
    y2: 313.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1487_155510",
    x1: 152.961,
    y1: 232.661,
    x2: 152.961,
    y2: 247.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1487_155510",
    x1: 77.0284,
    y1: 275.144,
    x2: 77.0284,
    y2: 291.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1487_155510",
    x1: 95.6664,
    y1: 264.353,
    x2: 95.6664,
    y2: 280.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1487_155510",
    x1: 114.302,
    y1: 253.564,
    x2: 114.302,
    y2: 269.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1487_155510",
    x1: 132.922,
    y1: 242.774,
    x2: 132.922,
    y2: 258.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1487_155510",
    x1: 190,
    y1: 235,
    x2: 27.0001,
    y2: 333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1487_155510",
    x1: 171.5,
    y1: 261,
    x2: 133,
    y2: 354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1487_155510",
    x1: 92.3898,
    y1: 305.661,
    x2: 92.3898,
    y2: 321.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1487_155510",
    x1: 72.8646,
    y1: 316.447,
    x2: 72.8646,
    y2: 333.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1487_155510",
    x1: 186.95,
    y1: 252.416,
    x2: 186.95,
    y2: 267.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1487_155510",
    x1: 111.018,
    y1: 294.896,
    x2: 111.018,
    y2: 310.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1487_155510",
    x1: 129.64,
    y1: 284.107,
    x2: 129.64,
    y2: 300.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1487_155510",
    x1: 148.278,
    y1: 273.32,
    x2: 148.278,
    y2: 289.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1487_155510",
    x1: 166.897,
    y1: 262.532,
    x2: 166.897,
    y2: 278.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1487_155510",
    x1: 60.5,
    y1: 321,
    x2: 57.5,
    y2: 339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42307D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1487_155510",
    x1: 193.138,
    y1: 243.977,
    x2: 63.6499,
    y2: 322.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1487_155510",
    x1: 161,
    y1: 166.5,
    x2: 145,
    y2: 198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BBC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1487_155510",
    x1: 157,
    y1: 151,
    x2: 111,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98A2B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1487_155510",
    x1: 141.112,
    y1: 129.637,
    x2: 131.5,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1487_155510",
    x1: 157,
    y1: 139.5,
    x2: 140.5,
    y2: 169.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1487_155510",
    x1: 141.097,
    y1: 133.604,
    x2: 141.097,
    y2: 144.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1487_155510",
    x1: 141.107,
    y1: 115.058,
    x2: 141.107,
    y2: 137.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1487_155510",
    x1: 141.094,
    y1: 110.277,
    x2: 138.5,
    y2: 119.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1487_155510",
    x1: 171.089,
    y1: 214.101,
    x2: 171.089,
    y2: 226.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1487_155510",
    x1: 171.358,
    y1: 208.182,
    x2: 171.358,
    y2: 215.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98A2B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1487_155510",
    x1: 171.119,
    y1: 197.579,
    x2: 171.119,
    y2: 214.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1487_155510",
    x1: 171.5,
    y1: 191,
    x2: 171.5,
    y2: 202.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98A2B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1487_155510",
    x1: 171.089,
    y1: 180.261,
    x2: 171.089,
    y2: 200.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1487_155510",
    x1: 171,
    y1: 158.5,
    x2: 171.072,
    y2: 179.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1487_155510",
    x1: 86.9782,
    y1: 117.204,
    x2: 87,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37404D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475467"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1487_155510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3733,
    height: 22.3733,
    fill: "white",
    transform: "translate(293.499 88.1455)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1487_155510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.8074,
    height: 23.8074,
    fill: "white",
    transform: "translate(94.4586 45.5029)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMAchineIllustrator);
export default __webpack_public_path__ + "static/media/MAchineIllustrator.be28fbfc60f11129a7b7312a4ff2e8c5.svg";
export { ForwardRef as ReactComponent };